import { Link } from "react-router-dom";

export default function ExternalLink({ target, rel, tag, children, ...props }) {
  target = target ?? '_blank';
  rel = rel ?? 'noreferrer noopener';
  const Tag = tag ?? (props.href ? 'a' : Link);
  return <Tag rel={rel} target={target} {...props}>{children}</Tag>;
}
